import * as actionTypes from './constants';
import { langSelector } from '../Category/selectors';
import { prop } from 'eshop-defaults';
import { resolveCurrentThemeFromCategory } from '../../utilities/category';
import { setCurrentTheme } from '../App/actions';
import { userSelector } from '../App/selectors';
import { AppThunk } from '../../rootReducer';
import * as cookies from 'react-cookies';

const requestProductDetail = () => ({
  type: actionTypes.REQUEST_PRODUCT_DETAIL,
});

const receiveProductDetailSuccess = productDetail => ({
  type: actionTypes.RECEIVE_PRODUCT_DETAIL_SUCCESS,
  payload: {
    productDetail,
  },
});

const receiveProductDetailError = error => ({
  type: actionTypes.RECEIVE_PRODUCT_DETAIL_ERROR,
  payload: {
    error,
  },
});

export const loadProductDetail = (id, pathname, reqData: any): AppThunk => {
  return async (dispatch, getState, API) => {
    // if (!productId || productId.toString() !== id.toString()) {
    try {
      dispatch(requestProductDetail());
      console.log('requesting product');
      const lang = langSelector(getState());
      const productDetail = await API.loadProduct(
        id,
        {
          withParentCategories: '1',
          withProductPackages: '1',
          withCustomOrderNr: '1',
          goodsWithStores: '1',
          withFreeDelivery: '1',
        },
        { xAcceptLanguage: lang },
      );
      dispatch(receiveProductDetailSuccess(productDetail));
      console.log('received product');
      const productCategories = prop(productDetail, 'parent_categories');
      if (productCategories) {
        const uniqueCatIds: string[] = productCategories.map(
          p => p.category_number,
        );
        const theme = resolveCurrentThemeFromCategory(uniqueCatIds);
        dispatch(setCurrentTheme(theme, pathname));
      }

      if (productDetail) {
        try {
          const userAgent = prop(reqData, 'userAgent');
          const userIP = prop(reqData, 'userIP');
          const reqCookies = prop(reqData, 'cookies');
          let userFBP = '';
          try {
            userFBP = reqCookies
              ? reqCookies
                  .split('; ')
                  .find(row => row.startsWith('_fbp='))
                  ?.split('=')[1]
              : '';
          } catch (e) {
            //
          }
          if (!userFBP) {
            userFBP = cookies.load('_fbp') || '';
          }
          await API.sendFacebookEvent(
            {},
            {
              event_name: 'ViewContent',
              event_time: Math.floor(Date.now() / 1000),
              client_ip_address: userIP,
              client_user_agent: userAgent,
              lang: 'sk',
              fbp: userFBP,
              event_source_url: 'www.zemplin.sk/' + pathname,
              products: [
                { id: prop(productDetail, 'product_id'), quantity: 1 },
              ],
            },
          );
        } catch (e) {
          console.error('Error in fetching finished order analytics', e);
        }
      }
    } catch (e) {
      dispatch(receiveProductDetailError(e));
    }
    // }
  };
};

const requestProductDetailRelated = () => ({
  type: actionTypes.REQUEST_PRODUCT_RELATED_DETAIL,
});

const receiveProductDetailRelatedSuccess = connections => ({
  type: actionTypes.RECEIVE_PRODUCT_RELATED_DETAIL_SUCCESS,
  payload: {
    connections,
  },
});

const receiveProductDetailRelatedError = error => ({
  type: actionTypes.RECEIVE_PRODUCT_DETAIL_RELATED_ERROR,
  payload: {
    error,
  },
});

export const loadProductDetailRelated = id => {
  return async (dispatch, getState, API) => {
    try {
      dispatch(requestProductDetailRelated());

      const lang = langSelector(getState());
      const connections = await API.loadProductConnections(
        id,
        {
          connectionType: 'ALTERNATIVE',
          limit: 12,
        },
        { xAcceptLanguage: lang },
      );
      dispatch(receiveProductDetailRelatedSuccess(connections));
    } catch (e) {
      dispatch(receiveProductDetailRelatedError(e));
    }
  };
};

const requestProductDetailAccessory = () => ({
  type: actionTypes.REQUEST_PRODUCT_ACCESSORY_DETAIL,
});

const receiveProductDetailAccessorySuccess = connections => ({
  type: actionTypes.RECEIVE_PRODUCT_ACCESSORY_DETAIL_SUCCESS,
  payload: {
    connections,
  },
});

const receiveProductDetailAccessoryError = error => ({
  type: actionTypes.RECEIVE_PRODUCT_DETAIL_ACCESSORY_ERROR,
  payload: {
    error,
  },
});

export const loadProductDetailAccessory = id => {
  return async (dispatch, getState, API) => {
    try {
      dispatch(requestProductDetailAccessory());

      const lang = langSelector(getState());
      const connections = await API.loadProductConnections(
        id,
        {
          connectionType: 'ACCESSORY',
          limit: 12,
        },
        { xAcceptLanguage: lang },
      );
      dispatch(receiveProductDetailAccessorySuccess(connections));
    } catch (e) {
      dispatch(receiveProductDetailAccessoryError(e));
    }
  };
};

export const setCustomerGoodOrderNr = (goodId: number, value: string) => {
  return async (dispatch, getState, API) => {
    try {
      const user = userSelector(getState());

      await API.updateCustomOrderNumber(
        user.id,
        goodId,
        {},
        { orderNr: value },
      );
    } catch (e) {
      console.log({ e });
    }
  };
};
